import moment from 'moment-timezone';

// Because we are showing the larger, umbrella timezones in the UI, this list covers the vast majority of timezones in the US (not including territories)
// If we encounter a zone with a specific offset/dst observance we should add it here
export const SDTC_TIME_ZONES: { [timeZoneId: string]: string } = {
  'America/New_York': 'Eastern Time',
  'America/Chicago': 'Central Time',
  'America/Denver': 'Mountain Time',
  'America/Phoenix': 'Arizona Mountain Time',
  'America/Los_Angeles': 'Pacific Time',
  'America/Anchorage': 'Alaska Time',
  'Pacific/Honolulu': 'Hawaii-Aleutian Time',
  'America/Adak': 'Hawaii-Aleutian Time (DST Observed)',
};

export const SDTC_TIME_ZONE_OPTIONS: SelectOption<string>[] = Object.keys(SDTC_TIME_ZONES).map(
  (timeZoneId) => ({ label: SDTC_TIME_ZONES[timeZoneId], value: timeZoneId }),
);

export const DEFAULT_SDTC_SEND_TIME = '12:00:00';
export const DEFAULT_SDTA_SEND_TIME = '08:00:00';
export const DEFAULT_SDTC_SEND_TIMEZONE = 'America/New_York';

const timeZoneOrder = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Adak',
];

export const getTimeZoneFromOffset = () => {
  const localOffset = new Date().getTimezoneOffset();
  let localTimeZone = DEFAULT_SDTC_SEND_TIMEZONE;

  timeZoneOrder.forEach((zoneId) => {
    const zoneOffset = moment.tz.zone(zoneId)?.parse(Date.now());
    if (zoneOffset === localOffset) {
      if (zoneId === 'America/Phoenix' && localTimeZone === 'America/Denver') {
        // give larger Mountain Time precedence over Arizona Mountain Time - more people will have to swap from AMT to MT than MT to AMT
        localTimeZone = 'America/Denver';
      } else {
        localTimeZone = zoneId;
      }
    }
  });

  return localTimeZone;
};
